import { FC, useContext } from 'react';
import { ConfigurationContext, UserInfoContext } from '../../../Context';
import { useSurveyDescription } from '../../../Components/Roboscreener';
import { LeftSidebarProps } from './shared/types';
import { OtherUsersViewingSection } from './components/OtherUsersViewingSection';
import { RelatedCasesSection } from './components/RelatedCasesSection';
import { ContextSection } from './components/ContextSection';
import { TagsSection } from './components/TagsSection';
import { ApplicantInfoSection } from './components/ApplicantInfoSection';

/**
 * Left sidebar showing case context, tags, and applicant information
 */
export const LeftSidebar: FC<LeftSidebarProps> = ({
  caseInfo,
  relatedCases,
  applicantInfo,
  applicantUid,
  verifiedContacts
}) => {
  const config = useContext(ConfigurationContext);
  const userContext = useContext(UserInfoContext);
  const currentUserName = config?.user?.name || userContext?.uid || 'Unknown User';
  const infoDefs = useSurveyDescription({ getContent: true });

  return (
    <div className="p-4 space-y-6 overflow-x-hidden min-w-0 h-full">
      {/* Other Users Viewing */}
      <OtherUsersViewingSection caseId={caseInfo.uid} currentUserName={currentUserName} />

      {/* Related Cases */}
      <RelatedCasesSection relatedCases={relatedCases} />

      {/* Context Section */}
      <ContextSection
        caseInfo={caseInfo}
        applicantInfo={applicantInfo}
        applicantUid={applicantUid}
        verifiedContacts={verifiedContacts}
      />

      {/* Tags Section */}
      <TagsSection caseInfo={caseInfo} />

      {/* Applicant Info Section */}
      <ApplicantInfoSection
        applicantInfo={applicantInfo}
        applicantUid={applicantUid}
        infoDefs={infoDefs}
      />
    </div>
  );
};
